import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  const data = _taggedTemplateLiteral(["\n            color: #56b6c2;\n        "]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n            color: #d19a66;\n        "]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n            color: #98c379;\n        "]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n            color: #d19a66;\n        "]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n            color: #c678dd;\n        "]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            color: #999;\n        "]);

  _templateObject = function () {
    return data;
  };

  return data;
}
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO


import React from 'react';
import { stringReplace } from './stringReplace';
import styled from 'styled-components';
import { uniqueId } from 'lodash';
export const highlightCode = code => {
  let newCode = typeof code === 'string' ? [code] : code;

  for (const style of styles) {
    newCode = mapCode(newCode, c => highlight(c, style.reg, style.Comp));
  }

  return newCode;
};

const mapCode = (code, fn) => code.map(item => typeof item === 'string' ? fn(item) : item).flat();

const highlight = (code, reg, Comp) => stringReplace(code, reg, key => React.createElement(Comp, {
  key: uniqueId('highlight-'),
  value: key
}, key));

const Color = ({
  value
}) => React.createElement("span", {
  style: {
    color: value
  }
}, value);

const styles = [{
  reg: /(\/\/.+)/g,
  Comp: styled.span(_templateObject())
}, {
  reg: /\b(if|else|return|for|while|of|=>)\b/g,
  Comp: styled.span(_templateObject2())
}, {
  reg: /(#[0-9a-fA-F]{3,6})/g,
  Comp: Color
}, {
  reg: /\b(true|false|undefined|null)\b/g,
  Comp: styled.span(_templateObject3())
}, {
  reg: /(["'`](.*?)["'`])/g,
  Comp: styled.span(_templateObject4())
}, {
  reg: /\b(\d+(%|em|rem|px|s|vh|vw|vmax|vmin|ex|ch|deg|turn|rad|grad|\.)*)\b/g,
  Comp: styled.span(_templateObject5())
}, {
  reg: /([=!@$%^&*<>|]+)/g,
  Comp: styled.span(_templateObject6())
}];